<app-card
  title="Enter Payment Information"
  headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title"
  contentClasses="p-4"
>
  <app-consultation-order-summary
    [consultationRequestPaymentForm]="consultationRequestPaymentForm"
    [isFreeSelected]="isFreeSelected"
    [payments]="payments"
    (fullDiscountApplied)="onFullDiscountApplied()"
  ></app-consultation-order-summary>
  <ngx-payment-form
    #ngxPaymentForm
    class="payment-form"
    [totalAmount]="consultationRequestService.getTotal() / 100"
    (paymentsSelected)="onPaymentsSelected($event)"
    (formValid)="formValid.emit()"
    [(selectedPaymentType)]="selectedPaymentType"
  ></ngx-payment-form>
</app-card>
